import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IntegrationSlugEnum } from 'types/integrations';
import showToast from 'utils/toast';
import usePusher from './usePusher';

type Event = null | {
  data: { slug: IntegrationSlugEnum.peppol };
};

const usePeppolDeactiveEvent = () => {
  const { t } = useTranslation();
  const channel = usePusher();

  useEffect(() => {
    if (!channel) return;

    const handler = (event: Event) => {
      if (!event) return;
      if (event.data.slug !== IntegrationSlugEnum.peppol) return;

      showToast(
        {
          title: t('peppol.deactivation.alert'),
        },
        {
          type: 'info',
        },
      );
    };

    channel.bind('user.integration.deactivated', handler);
    return () => {
      channel.unbind('user.integration.deactivated', handler);
    };
  }, [channel]);
};

export default usePeppolDeactiveEvent;
